export const required = () => ({
  required: 'trans:common:common.form.error.field.required',
})

type TMM = 'min' | 'max'

export const check = <CheckName extends TMM | `${TMM}Length` | 'pattern'>(
  checkName: CheckName,
  value: CheckName extends 'pattern' ? RegExp : CheckName extends `${TMM}Length` ? number : string | number,
  message: string,
) => ({
  [checkName]: { value, message },
})

export const email = () =>
  check(
    'pattern',
    /^(?:[\w!#$%&'*+\-/=?^`{|}~]+\.)*[\w!#$%&'*+\-/=?^`{|}~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/,
    'trans:common:common.form.error.email.invalid',
  )

export const customCondition = (predicate: (inputValue: string | number) => boolean, errorMessage?: string) => ({
  validate: (inputValue: string) =>
    predicate(inputValue) || (errorMessage ?? 'trans:common:common.form.error.field.invalid'),
})
